import { useParams } from "react-router-dom";

import { GroupContent } from "./components/GroupContent";

export default function GroupInfo() {
  // Get ID from URL requestId
  const { groupId } = useParams();

  return <GroupContent groupId={groupId ?? ""} />;
}
